import {
	EDIT_REGION,
	EDIT_REGION_SUCCESS,
	EDIT_REGION_FAIL,
	EDIT_REGION_RESET,
} from '../actions/editRegionAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const editRegionReducer = (state = initialState, action) => {
	switch (action.type) {
		case EDIT_REGION:
			return {
				...state,
				apiState: 'loading',
			};
		case EDIT_REGION_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case EDIT_REGION_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case EDIT_REGION_RESET:
			return initialState;
		default:
			return state;
	}
};

export default editRegionReducer;
